import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UiShowcaseComponent } from './ui-showcase.component';

const routes: Routes = [
  {
    path: 'ui-showcase',
    component: UiShowcaseComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class UiShowcaseRoutingModule {}
